import './Accordion.scss';

const Accordion = ({ title, content, isActive, onToggle }) => {
  return (
    <div className="accordion-item">
      <div className="accordion-title" onClick={onToggle}>
        <div>{isActive ? '-' : '+'}</div>
        <div>{title}</div>
      </div>
      {isActive && (
        <div className="accordion-content" dangerouslySetInnerHTML={{ __html: content }} />
      )}
    </div>
  );
};

export default Accordion;
